// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.toggle-buttons_row_qnLTK {
    display: flex;
    flex-direction: row;
}

.toggle-buttons_button_Y53uc {
    margin: 0;
    padding: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    background: none;
    outline: none;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    position: relative;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.toggle-buttons_button_Y53uc > img {
    display: block;
    transition: transform 0.1s;
    filter: var(--filter-icon-gray);
}

.toggle-buttons_button_Y53uc:not(:last-child) {
    border-right: none;
}

[dir="rtl"] .toggle-buttons_button_Y53uc:not(:last-child) {
    border-left: none;
    border-right: 1px solid var(--ui-black-transparent);
}

.toggle-buttons_button_Y53uc:focus::before {
    content: "";
    position: absolute;
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    border: 1px solid var(--looks-secondary);
}

/* round corners for first and last buttons */

.toggle-buttons_button_Y53uc:first-child,
[dir="rtl"] .toggle-buttons_button_Y53uc:last-child,
.toggle-buttons_button_Y53uc:first-child:focus::before,
[dir="rtl"] .toggle-buttons_button_Y53uc:last-child:focus::before {
    border-radius: calc(0.5rem / 2) 0 0 calc(0.5rem / 2);
}

.toggle-buttons_button_Y53uc:last-child,
[dir="rtl"] .toggle-buttons_button_Y53uc:first-child,
.toggle-buttons_button_Y53uc:last-child:focus::before,
[dir="rtl"] .toggle-buttons_button_Y53uc:first-child:focus::before {
    border-radius: 0 calc(0.5rem / 2) calc(0.5rem / 2) 0;
}

/* selected button styling */

.toggle-buttons_button_Y53uc[aria-pressed='true'] {
    background-color: var(--looks-light-transparent);
}

.toggle-buttons_button_Y53uc[aria-pressed='true'] > img {
    filter: none;
}

/* pressed button styling */

.toggle-buttons_button_Y53uc:active {
    background-color: var(--looks-transparent);
}

/* disabled styling */

.toggle-buttons_disabled_xspCY .toggle-buttons_button_Y53uc {
    cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/toggle-buttons/toggle-buttons.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,6CAA6C;IAC7C,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,wCAAwC;AAC5C;;AAEA,6CAA6C;;AAE7C;;;;IAII,oDAAoD;AACxD;;AAEA;;;;IAII,oDAAoD;AACxD;;AAEA,4BAA4B;;AAE5B;IACI,gDAAgD;AACpD;;AAEA;IACI,YAAY;AAChB;;AAEA,2BAA2B;;AAE3B;IACI,0CAA0C;AAC9C;;AAEA,qBAAqB;;AAErB;IACI,eAAe;AACnB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.row {\n    display: flex;\n    flex-direction: row;\n}\n\n.button {\n    margin: 0;\n    padding: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    background: none;\n    outline: none;\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    position: relative;\n    width: 34px;\n    height: 34px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.button > img {\n    display: block;\n    transition: transform 0.1s;\n    filter: var(--filter-icon-gray);\n}\n\n.button:not(:last-child) {\n    border-right: none;\n}\n\n[dir=\"rtl\"] .button:not(:last-child) {\n    border-left: none;\n    border-right: 1px solid var(--ui-black-transparent);\n}\n\n.button:focus::before {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    bottom: -1px;\n    left: -1px;\n    border: 1px solid var(--looks-secondary);\n}\n\n/* round corners for first and last buttons */\n\n.button:first-child,\n[dir=\"rtl\"] .button:last-child,\n.button:first-child:focus::before,\n[dir=\"rtl\"] .button:last-child:focus::before {\n    border-radius: calc(0.5rem / 2) 0 0 calc(0.5rem / 2);\n}\n\n.button:last-child,\n[dir=\"rtl\"] .button:first-child,\n.button:last-child:focus::before,\n[dir=\"rtl\"] .button:first-child:focus::before {\n    border-radius: 0 calc(0.5rem / 2) calc(0.5rem / 2) 0;\n}\n\n/* selected button styling */\n\n.button[aria-pressed='true'] {\n    background-color: var(--looks-light-transparent);\n}\n\n.button[aria-pressed='true'] > img {\n    filter: none;\n}\n\n/* pressed button styling */\n\n.button:active {\n    background-color: var(--looks-transparent);\n}\n\n/* disabled styling */\n\n.disabled .button {\n    cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `toggle-buttons_row_qnLTK`,
	"button": `toggle-buttons_button_Y53uc`,
	"disabled": `toggle-buttons_disabled_xspCY`
};
export default ___CSS_LOADER_EXPORT___;
